/**
 * z-index constants for DOM overlays anchored to the Phaser canvas.
 *
 * Reserved gaps (don't use 21-24, 29) so future surfaces slot in
 * cleanly. PartyOrbs + popover + PartySheetScene + joystick.ts all
 * import from this module.
 *
 *   joystick.ts was using a magic 20 prior to this module — kept the
 *   value here as `Z_JOYSTICK` and updated joystick.ts to import. Any
 *   future DOM overlay should pick the next gap rather than hard-coding
 *   a number.
 *
 * Phaser-rendered chrome that lives inside the canvas (battle UI, modal
 * scenes, dialogue) shares the canvas's stacking context, so DOM
 * overlay z-indexes layer above them naturally. The values here partition
 * within the DOM-overlay layer only.
 */
/** VoxelPreviewScene's own WebGL canvas. The one surface that must sit
 *  ABOVE the Phaser canvas (it replaces the view entirely) but below
 *  every DOM overlay — including the mode picker at 6, which is how the
 *  player got here. Its HUD pills take Z_VOXEL_PREVIEW + 1. */
export const Z_VOXEL_PREVIEW = 4;
export const Z_JOYSTICK = 20;
/** Route-name placard pill on every region cross — top-left, transient
 *  (2.2s lifecycle: 200ms fade-in / 1800ms dwell / 200ms fade-out). Sits
 *  below party orbs in case the placard's footprint ever overlaps the
 *  orb strip on landscape phones. */
export const Z_ROUTE_PLACARD = 24;
export const Z_PARTY_ORBS = 25;
export const Z_OVERLAY_GLYPHS = 26;
export const Z_POPOVERS = 27;
/** PartySheetScene's transparent backdrop + sheet panel. Above the popover
 *  so dismissing the popover never renders on top of an open sheet. */
export const Z_PARTY_SHEET = 28;
/** Reserved for the upcoming Liquid Glass dialogue overhaul. */
export const Z_DIALOGUE = 30;
export const Z_DEV_HUD = 100;
